var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"logo",style:({height: _vm.height + 'px'}),attrs:{"src":require("@/assets/images/logo.svg"),"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }